import type { CSSProperties } from 'react';

export function tintStyle(color: string): CSSProperties {
  return {
    '--tint-color': color,
  } as CSSProperties;
}
